import { RawTimelineEvent } from "@app/types/events/TimelineEvent";

import getCheckInEntityRef, { CheckInEntityRef } from "./getCheckInEntityRef";
import getRecordAddedEntityRef, { RecordAddedEntityRef } from "./getRecordAddedEntityRef";

// The record a timeline card draws a marker for: the visited record of a check-in, or the created
// record of a record-added event. The two are exclusive — a check-in's entity is the activity — so
// the first match wins. Kept in one place because the fetch that resolves the colors and the
// renderer that reads them must agree on which events are colorable.
const getTimelineEventEntityRef = (
  event: RawTimelineEvent
): CheckInEntityRef | RecordAddedEntityRef | undefined =>
  getCheckInEntityRef(event) ?? getRecordAddedEntityRef(event);

export default getTimelineEventEntityRef;
